export default {
  props: {
    loaded: {
      type: Boolean,
      required: true
    }
  },
  template: `
    <div>
      <transition name="fade" mode="out-in">
        <div class="loader" v-if="loaded"></div>
        <slot v-else></slot>
      </transition>
    </div>
  `
};



// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/ui/loader.js